import {geoService} from './GeoService.js';
import {computed, observable} from 'mobx';
import {fromPromise} from 'mobx-utils';

export class AddressCoordinate {
    @observable street = '';
    @observable zipCode = '';
    @observable city = '';

    constructor(init) {
        this.street = init.street;
        this.zipCode = init.zipCode;
        this.city = init.city;
        this.defaultCoords = {
            lat: init.lat === undefined ? Infinity : init.lat,
            lng: init.lng === undefined ? Infinity : init.lng,
        };
    }

    /** @private */
    @computed get coordinates_() {
        const {fullAddress} = this;
        const promise = fullAddress ?
            geoService.coordinatesForAddress(fullAddress) :
            Promise.resolve(this.defaultCoords);
        return fromPromise(promise);
    }

    @computed get lat() {
        return this.coordinates_.case({
            pending: () => this.defaultCoords.lat,
            fulfilled: value => value ? value.lat : this.defaultCoords.lat,
            rejected: () => this.defaultCoords.lat,
        });
    }

    @computed get lng() {
        return this.coordinates_.case({
            pending: () => this.defaultCoords.lng,
            fulfilled: value => value ? value.lng : this.defaultCoords.lng,
            rejected: () => this.defaultCoords.lng,
        });
    }

    @computed get fullAddress() {
        return [this.street, this.zipCode, this.city]
            .filter(v => v && v.length > 2).join(', ');
    }
}



// WEBPACK FOOTER //
// ./web/js/services/AddressCoordinate.js